// Filter and Sorting jQuery for the trust finder page.

(function ($) {
    $(document).ready(function () {

        /*
        * Show/Hide Filter on small screens.
        */
        $('#toggle-filters').click(function () {
            $('#filters').slideToggle(
                'fast',
                function () {
                    // Change button text based on visibility.
                    let isVisible = $('#filters').is(':visible');
                    $('#toggle-filters').html(isVisible ? 'Hide Filters <i class="jh-icon-Arrow-Up"></i>' : 'Show Filters <i class="jh-icon-Arrow-Down"></i>');
                }
            );
        });

        /*
        * Sorting
        */
        $('.trust-finder__table th').on('click', function () {
            let column = $(this).index(); // Get index of clicked column.
            let table = $(this).closest('table');
            let rows = table.find('tr:gt(0)').toArray().sort(
                function (rowA, rowB) {
                    let cellA = $(rowA).find('td').eq(column).text();
                    let cellB = $(rowB).find('td').eq(column).text();

                    // Customize sorting based on the column.
                    switch (column) {
                        case 0: // Name.
                        case 1: // Ticker.
                            return cellA.localeCompare(cellB);
                        case 2: // Share Price GBX.
                        case 4: // Discount/Premium %.
                        case 5: // Yield %.
                            return parseFloat(cellA.replace(/[^0-9.-]+/g, "")) - parseFloat(cellB.replace(/[^0-9.-]+/g, ""));
                        case 3: // Price Date.
                            let dateA = new Date(cellA.split('/').reverse().join('-'));
                            let dateB = new Date(cellB.split('/').reverse().join('-'));
                            return dateA - dateB;
                        default:
                            return cellA.localeCompare(cellB);
                    }
                }
            );

            // Check if the column is already sorted in ascending order.
            let isAscending = $(this).hasClass('asc');
            if (isAscending) {
                rows = rows.reverse();
            }

            // Remove asc/desc classes from all headers.
            $('th').removeClass('asc desc');

            // Toggle class based on current sorting order.
            $(this).addClass(isAscending ? 'desc' : 'asc');

            // Append sorted rows back to the table.
            $.each(rows, function (index, row) {
                table.append(row);
            });
            resetStriping()
        });

        /*
        * Filtering
        */
        $('input[type="checkbox"]').on('change', function () {
            filterTable();
            resetStriping();
            updateTableMessage();
        });

        function filterTable() {
            // Selects all checked input elements with the name attribute "regional-focus"
            // iterate over each element in the jQuery object
            let regionalFocusFilters = $('input[name="regional-focus"]:checked').map(
                // apply a function to each item in the matched set and construct a new jQuery object from the returned values.
                function () {
                    return $(this).val();  // return the value of the input
                }
            ).get(); //then convert this jQuery object into a plain JavaScript array containing the values of the checked input elements.

            // ^ Same, but for "objective"
            let objectiveFilters = $('input[name="objective"]:checked').map(
                function () {
                    return $(this).val();
                }
            ).get();

            $('.trust-finder__table tbody tr').each(
                function () {
                    let regionalFocus = $(this).data('regional-focus');
                    let objective = $(this).data('objective');
                    //  Determine whether a specific row should be shown/hidden based on the presence of
                    //  regionalFocus and objective within the two arrays, regionalFocusFilters and objectiveFilters.
                    let showRow = (regionalFocusFilters.length === 0 || regionalFocusFilters.includes(regionalFocus)) &&
                        (objectiveFilters.length === 0 || objectiveFilters.includes(objective));
                    // showRow will be true/false.
                    $(this).toggle(showRow);
                }
            );
        }

        /*
        * Update Table Message
        */
        function updateTableMessage() {
            console.log("update clicked");
            let $tableBody = $('.trust-finder__table tbody');
            let visibleRows = $tableBody.find('tr:visible').length;
            let messageRowClass = 'noproductsmessage'; // A class for the message row

            // Remove the message row if it exists, to avoid duplicates or incorrect states
            $('.' + messageRowClass).remove();

            // If there are no visible rows, append the message row
            if (visibleRows === 0) {
                let colCount = $('.trust-finder__table thead th').length; // Count the columns to span the message
                let messageRow = `<tr class="${messageRowClass}"><td colspan="${colCount}">No matching products found. You may want to <span class="trigger-reset-link">reset</span> your filters to expand the results.</td></tr>`;
                $tableBody.append(messageRow);
            }
        }

        /*
        * Reset Striping for altered table
        */
        function resetStriping() {
            $('.trust-finder__table tbody tr:visible').each(
                function (index) {
                    $(this).css('background-color', !!(index & 1) ? '#F0F7F9' : '#FFFFFF');
                }
            );
        }

        /*
        * Reset filter checkbox's and show all table rows
        */
        $('.finder__reset').click(function () {
            $('#filters input[type="checkbox"]').prop('checked', false);
            $('.trust-finder__table tbody tr').each(function () {
                $(this).show();
            });
            updateTableMessage();
            resetStriping();
        });

        // Add a click event handler for the "reset" link
        $(document).on('click', '.trigger-reset-link', function () {
            $('.finder__reset').trigger('click');
        });
    });
})(jQuery);
